var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: {
            title: _vm.data ? "Edit Push" : "Create Push",
            visible: _vm.dialogVisible,
            width: "65vw",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            open: _vm.onOpen,
            closed: _vm.onClosed,
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "form",
              staticClass: "padding-lr",
              attrs: {
                model: _vm.form,
                rules: _vm.formRules,
                "label-width": "150px",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "", prop: "" } }, [
                _c("p", { staticClass: "right-find" }, [
                  _c("i", { staticClass: "el-icon-warning-outline" }),
                  _vm._v(
                    "请务必确保礼来有使用以下内容的版权，如需查询，烦请使用VPN登录此网站： "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.rightfind.com",
                        target: "_blank",
                      },
                    },
                    [_vm._v("https://www.rightfind.com")]
                  ),
                ]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "Greetings", prop: "greeting" } },
                [
                  _c("el-input", {
                    staticClass: "greet-input",
                    attrs: {
                      placeholder: "Please input greetings",
                      maxlength: "100",
                    },
                    model: {
                      value: _vm.form.greeting,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "greeting", $$v)
                      },
                      expression: "form.greeting",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  ref: "pushToMSL",
                  staticStyle: { "margin-bottom": "5px!important" },
                  attrs: { label: "Setting", prop: "pushToMSL" },
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { disabled: _vm.disablePushToMSL },
                          model: {
                            value: _vm.form.pushToMSL,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "pushToMSL", $$v)
                            },
                            expression: "form.pushToMSL",
                          },
                        },
                        [_vm._v("Push to Me")]
                      ),
                      _vm.disablePushToMSL
                        ? _c(
                            "el-button",
                            {
                              staticClass: "bind-wechat-link",
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.bindWeChat()
                                },
                              },
                            },
                            [_vm._v(" Bind WeChat? ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "push-to-msl-msg",
                      attrs: { slot: "error" },
                      slot: "error",
                    },
                    [_vm._v(_vm._s(_vm.pushToMSLMsg))]
                  ),
                ]
              ),
              _c(
                "el-form-item",
                {
                  style: {
                    "margin-bottom": _vm.form.scheduled
                      ? "16px!important"
                      : "5px!important",
                  },
                  attrs: { prop: "scheduleDate" },
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          on: { change: _vm.onScheduleChange },
                          model: {
                            value: _vm.form.scheduled,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "scheduled", $$v)
                            },
                            expression: "form.scheduled",
                          },
                        },
                        [_vm._v(" Scheduled ")]
                      ),
                      _vm.form.scheduled
                        ? _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 4 } },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      type: "date",
                                      format: _vm.dateFormat,
                                      "value-format": _vm.dateFormat,
                                      placeholder: "Select Date",
                                      editable: false,
                                    },
                                    model: {
                                      value: _vm.sDate,
                                      callback: function ($$v) {
                                        _vm.sDate = $$v
                                      },
                                      expression: "sDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 4 } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      ref: "sTime",
                                      staticClass: "times-select",
                                      attrs: {
                                        clearable: "",
                                        "allow-create": "",
                                        filterable: "",
                                        placeholder: "Select Time",
                                      },
                                      on: {
                                        blur: function ($event) {
                                          return _vm.onTimeBulr($event, "sTime")
                                        },
                                      },
                                      model: {
                                        value: _vm.sTime,
                                        callback: function ($$v) {
                                          _vm.sTime = $$v
                                        },
                                        expression: "sTime",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-input__icon el-icon-time",
                                        attrs: { slot: "prefix" },
                                        slot: "prefix",
                                      }),
                                      _vm._l(_vm.times, function (item, i) {
                                        return _c("el-option", {
                                          key: i,
                                          attrs: {
                                            label: item.value,
                                            value: item.value,
                                          },
                                        })
                                      }),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-form-item",
                {
                  ref: "isWeComSend",
                  staticStyle: { "margin-bottom": "5px!important" },
                  attrs: { prop: "isWeComSend" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "checkbox-wrapper" },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.isWeComSend,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "isWeComSend", $$v)
                            },
                            expression: "form.isWeComSend",
                          },
                        },
                        [_vm._v("WeCom Send")]
                      ),
                      _vm.form.isWeComSend
                        ? _c(
                            "el-checkbox",
                            {
                              on: { change: _vm.onContactsOnlyChange },
                              model: {
                                value: _vm.form.contactsOnly,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "contactsOnly", $$v)
                                },
                                expression: "form.contactsOnly",
                              },
                            },
                            [_vm._v("Contacts Only")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-form-item",
                { staticClass: "push-tag-filter", attrs: { label: "Tag" } },
                [
                  _c("HcpTagSelect", {
                    model: {
                      value: _vm.selectedTagIds,
                      callback: function ($$v) {
                        _vm.selectedTagIds = $$v
                      },
                      expression: "selectedTagIds",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  ref: "seIds",
                  attrs: { label: _vm.formItemLabel, prop: "seIds" },
                },
                [
                  _vm.isSupervisor || _vm.isMSL
                    ? _c(
                        "el-radio-group",
                        {
                          on: { input: _vm.changeSeType },
                          model: {
                            value: _vm.seType,
                            callback: function ($$v) {
                              _vm.seType = $$v
                            },
                            expression: "seType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "All" } }, [
                            _vm._v("All"),
                          ]),
                          _c("el-radio", { attrs: { label: "SE" } }, [
                            _vm._v("SE"),
                          ]),
                          _c("el-radio", { attrs: { label: "CE" } }, [
                            _vm._v("CE"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("SEMultipleSelect", {
                    attrs: {
                      showTips: true,
                      placeholder: _vm.selectPlaceholder,
                      options: _vm.seListByType,
                      type: "quickPush",
                    },
                    on: { "select-change": _vm.onSESelectChange },
                    model: {
                      value: _vm.form.seIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "seIds", $$v)
                      },
                      expression: "form.seIds",
                    },
                  }),
                  _c("div", { staticClass: "selected-hcp-count" }, [
                    _vm._v(" Selected: "),
                    _c("strong", [_vm._v(_vm._s(_vm.form.seIds.length))]),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "request-type",
                  attrs: { prop: "requestType", label: "Request Type" },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "Please Select Request Type",
                        loading: _vm.requestTypeLoading,
                      },
                      on: { change: _vm.onRequestTypeChange },
                      model: {
                        value: _vm.form.requestType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "requestType", $$v)
                        },
                        expression: "form.requestType",
                      },
                    },
                    _vm._l(_vm.pushTypes, function (type) {
                      return _c("el-option", {
                        key: type.key,
                        attrs: { label: type.value, value: type.key },
                      })
                    }),
                    1
                  ),
                  _vm.form.requestType === 0
                    ? [
                        _c("el-input", {
                          staticStyle: { "margin-top": "15px" },
                          attrs: {
                            placeholder: "Please input reason",
                            maxlength: 200,
                          },
                          model: {
                            value: _vm.form.requestContent,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "requestContent", $$v)
                            },
                            expression: "form.requestContent",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm.form.requestType === 1
                    ? [
                        _c(
                          "el-row",
                          {
                            staticClass: "row-line",
                            attrs: {
                              type: "flex",
                              align: "bottom",
                              justify: "space-between",
                            },
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticClass: "interaction-date-time",
                                attrs: { span: 12 },
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "top-label",
                                    attrs: {
                                      prop: "interactionDateTime",
                                      label: "Interaction date/time",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "datetime" },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c("el-date-picker", {
                                              attrs: {
                                                type: "date",
                                                format: _vm.dateFormat,
                                                "value-format": _vm.dateFormat,
                                                placeholder: "Date",
                                                editable: false,
                                              },
                                              model: {
                                                value: _vm.iDate,
                                                callback: function ($$v) {
                                                  _vm.iDate = $$v
                                                },
                                                expression: "iDate",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                ref: "iTime",
                                                staticClass: "times-select",
                                                attrs: {
                                                  clearable: "",
                                                  "allow-create": "",
                                                  filterable: "",
                                                  placeholder: "Time",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.onTimeBulr(
                                                      $event,
                                                      "iTime"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: _vm.iTime,
                                                  callback: function ($$v) {
                                                    _vm.iTime = $$v
                                                  },
                                                  expression: "iTime",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-input__icon el-icon-time",
                                                  attrs: { slot: "prefix" },
                                                  slot: "prefix",
                                                }),
                                                _vm._l(
                                                  _vm.times,
                                                  function (item, i) {
                                                    return _c("el-option", {
                                                      key: i,
                                                      attrs: {
                                                        label: item.value,
                                                        value: item.value,
                                                      },
                                                    })
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              {
                                staticClass: "interaction-type",
                                attrs: { span: 8 },
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "top-label",
                                    attrs: {
                                      prop: "interactionTypeId",
                                      label: "Interaction type",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "Interaction type",
                                        },
                                        model: {
                                          value: _vm.form.interactionTypeId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "interactionTypeId",
                                              $$v
                                            )
                                          },
                                          expression: "form.interactionTypeId",
                                        },
                                      },
                                      _vm._l(_vm.interTypes, function (t) {
                                        return _c("el-option", {
                                          key: t.key,
                                          attrs: {
                                            label: t.value,
                                            value: t.key,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm.form.requestType === 6 || _vm.form.requestType === 5
                    ? [
                        _c("el-input", {
                          staticStyle: { margin: "15px 0 10px" },
                          attrs: { placeholder: "Please input reason" },
                          model: {
                            value: _vm.form.requestContent,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "requestContent", $$v)
                            },
                            expression: "form.requestContent",
                          },
                        }),
                        _c(
                          "CheckboxGroup",
                          {
                            staticClass: "activity_options",
                            model: {
                              value: _vm.form.initActivities,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "initActivities", $$v)
                              },
                              expression: "form.initActivities",
                            },
                          },
                          _vm._l(_vm.activityOptions, function (activity) {
                            return _c(
                              "Checkbox",
                              {
                                key: activity.optionId,
                                staticStyle: { display: "block" },
                                attrs: { label: activity.optionId },
                              },
                              [_vm._v(" " + _vm._s(activity.optionValue) + " ")]
                            )
                          }),
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm.form.requestType === 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Request Content" } },
                    [
                      _c("el-input", {
                        staticClass: "greet-input",
                        attrs: {
                          placeholder: "Please input request content",
                          maxlength: 200,
                        },
                        model: {
                          value: _vm.form.requestContent,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "requestContent", $$v)
                          },
                          expression: "form.requestContent",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "Push Content" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: { plain: "" },
                      on: { click: _vm.showSelectDialog },
                    },
                    [_vm._v(" Select Content ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { plain: "" },
                      on: { click: _vm.showNewPaperDialog },
                    },
                    [_vm._v(" Upload Content ")]
                  ),
                  _c(
                    "ul",
                    { staticClass: "upload-files" },
                    _vm._l(_vm.files, function (file, i) {
                      return _c(
                        "li",
                        { key: i, staticClass: "upload-file-item" },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: file.AttachmentPath,
                                target: "_blank",
                                title: file.Content,
                              },
                            },
                            [
                              _c("i", { staticClass: "el-icon-document" }),
                              _vm._v(" " + _vm._s(file.Content) + " "),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.deleteFile(i)
                                },
                              },
                            },
                            [_c("i", { staticClass: "el-icon-close" })]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Full Article Request",
                    prop: "fullPaperRequest",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.fullPaperRequest,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "fullPaperRequest", $$v)
                        },
                        expression: "form.fullPaperRequest",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("Yes")]),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("No")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "editor",
                  attrs: { label: "Description", prop: "paperContent" },
                },
                [
                  _vm.visible
                    ? _c("TinymceEditor", {
                        attrs: { height: 200 },
                        model: {
                          value: _vm.form.paperContent,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "paperContent", $$v)
                          },
                          expression: "form.paperContent",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.previewing || _vm.loading,
                  },
                  on: { click: _vm.onPreview },
                },
                [_vm._v(" " + _vm._s(_vm.previewLabel) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.actionDisabled,
                    loading: _vm.loading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onSubmit(1)
                    },
                  },
                },
                [_vm._v(" Submit ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.actionDisabled, loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.onSubmit(0)
                    },
                  },
                },
                [_vm._v(" Save Draft ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("QRCodeDialog", {
        attrs: { visible: _vm.qrcodeDialogVisible, data: _vm.previewUrl },
        on: {
          "update:visible": function ($event) {
            _vm.qrcodeDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.previewUrl = $event
          },
        },
      }),
      _c("SelectContentDialog", {
        ref: "selectContentDialog",
        attrs: {
          visible: _vm.selectContentDialogVisible,
          selected: _vm.selectTableData,
          categoried: _vm.form.categoried,
          "paper-content": _vm.form.paperContent,
        },
        on: {
          "update:visible": function ($event) {
            _vm.selectContentDialogVisible = $event
          },
          select: _vm.onSelect,
          closed: _vm.onSelectDialogClosed,
          "clear-description": _vm.onClearDescription,
        },
      }),
      _c("PaperDialog", {
        attrs: {
          visible: _vm.newPaperDialogVisible,
          "paper-content": _vm.form.paperContent,
        },
        on: {
          "update:visible": function ($event) {
            _vm.newPaperDialogVisible = $event
          },
          success: _vm.onFileUpload,
          closed: _vm.onSelectDialogClosed,
          "clear-description": _vm.onClearDescription,
        },
      }),
      _c(
        "el-dialog",
        {
          staticClass: "custom-confirm-dialog",
          attrs: {
            title: "请确认推送的HCP",
            visible: _vm.customConfirmVisible,
            width: "40%",
            "show-close": false,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.customConfirmVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "confirm-content" }, [
            _vm.confirmedContactsNames
              ? _c("div", { staticClass: "contact-group" }, [
                  _c("div", { staticClass: "contact-title" }, [
                    _vm._v("已添加MSL企业微信联系人："),
                    _c("span", { staticClass: "contact-names" }, [
                      _vm._v(_vm._s(_vm.confirmedContactsNames)),
                    ]),
                  ]),
                  _c("div", { staticClass: "contact-desc" }, [
                    _vm._v("(可推送至医生微信)"),
                  ]),
                ])
              : _vm._e(),
            _vm.unconfirmedContactsNames.length > 0 &&
            _vm.confirmedContactsNames.length > 0
              ? _c("div", { staticClass: "confirm-divider" })
              : _vm._e(),
            _vm.unconfirmedContactsNames
              ? _c("div", { staticClass: "contact-group" }, [
                  _c("div", { staticClass: "contact-title" }, [
                    _vm._v("未添加MSL企业微信联系人："),
                    _c("span", { staticClass: "contact-names" }, [
                      _vm._v(_vm._s(_vm.unconfirmedContactsNames)),
                    ]),
                  ]),
                  _c("div", { staticClass: "contact-desc" }, [
                    _vm._v("(不可推送至医生微信)"),
                  ]),
                ])
              : _vm._e(),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.customConfirmCancel } }, [
                _vm._v("Cancel"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.customConfirmSubmit },
                },
                [_vm._v("Submit")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }